import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Velódromo Rio de Janeiro/velodromo.jpg';
import imagem2 from '../assets/images/Projetos/Velódromo Rio de Janeiro/velodromo-img2.jpg';
import imagem3 from '../assets/images/Projetos/Velódromo Rio de Janeiro/velodromo-img3.jpg';

const App = () => {
  const projectData = {
    date: "17/03/2017",
    title: "Velódromo Rio de Janeiro",
    images: [
      imagem1,
      imagem2,
      imagem3
    ],
    description:
    "Fornecimento de cabos de incêndio, para o velódromo do Rio de Janeiro",
    solutions: ["Solução de Cobertura Indoor, CFTV, Detecção de Incêndio"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;